<template>
  <div data-rocket-location-hash="8a18f7f5895499b1fef7290ea3e469f1" id="main-content">
    <div data-rocket-location-hash="bb4ab2b94b095110bb1a5adb2287a95a" id="sub-header" class="layout-full elementor-page-title">
      <div class="meta-header" >
        <div class="limit-wrapper vamtam-box-outer-padding">
          <div class="meta-header-inside">
            <header class="page-header" data-progressive-animation="page-title">
              <h1>{{projectStore.details.projectName}}</h1>
            </header>
            <div class="vamtam-meta-tax the-categories">
              <span class="visuallyhidden">Category</span>
              <a v-if="projectStore?.details?.categoryId?.parentId === null" :href="`/our-services/category/` + projectStore?.details?.categoryId?.slug" :rel="projectStore?.details?.categoryId?.name">{{ projectStore?.details?.categoryId?.name }}</a>
              <a v-else :href="`/our-services/details/` + projectStore?.details?.categoryId?.parentId?.slug + `/` + projectStore?.details?.categoryId?.slug" :rel="projectStore?.details?.categoryId?.name">{{ projectStore?.details?.categoryId?.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="main" role="main" class="vamtam-main layout-full" >
      <article class="single-post-wrapper full post-5384 post type-post status-publish format-standard has-post-thumbnail hentry category-projects tag-public-buildings">
        <div data-elementor-type="single-post" data-elementor-id="3769" class="elementor elementor-3769 elementor-location-single post-5384 post type-post status-publish format-standard has-post-thumbnail hentry category-projects tag-public-buildings" data-elementor-post-type="elementor_library">
          <section class="elementor-section elementor-top-section elementor-element elementor-element-718e420 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="718e420" data-element_type="section" data-e-type="section">
            <div data-rocket-location-hash="28e653860718e9e8235291129e117949" class="elementor-container elementor-column-gap-no">
              <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c222fae" data-id="c222fae" data-element_type="column" data-e-type="column">
                <div class="elementor-widget-wrap elementor-element-populated">
                  <div class="elementor-element elementor-element-aa92b56 elementor-widget elementor-widget-theme-post-content" data-id="aa92b56" data-element_type="widget" data-e-type="widget" data-widget_type="theme-post-content.default">
                    <div class="elementor-widget-container">
                      <div data-elementor-type="wp-post" data-elementor-id="5384" class="elementor elementor-5384" data-elementor-post-type="post">
                        <!--Banner-->
                        <section :style="{backgroundImage: `url(${projectStore.details.image})`}" class="elementor-section elementor-top-section elementor-element elementor-element-6ed6fbde elementor-section-full_width elementor-section-height-min-height elementor-section-stretched elementor-section-height-default elementor-section-items-middle" data-id="6ed6fbde" data-element_type="section" data-e-type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}">
                          <div class="elementor-container elementor-column-gap-default">
                            <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2fb51389" data-id="2fb51389" data-element_type="column" data-e-type="column">
                              <div class="elementor-widget-wrap">
                              </div>
                            </div>
                          </div>
                        </section>
                        <section class="elementor-section elementor-top-section elementor-element elementor-element-6712fc79 elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="6712fc79" data-element_type="section" data-e-type="section">
                          <div data-rocket-location-hash="c977a453272ec25e3fb209693a0cfc95" class="elementor-container elementor-column-gap-no">
                            <div class="elementor-column elementor-col-30 elementor-top-column elementor-element elementor-element-583e3751 elementor-invisible" data-id="583e3751" data-element_type="column" data-e-type="column" data-settings="{&quot;animation&quot;:&quot;fadeIn&quot;,&quot;animation_delay&quot;:300,&quot;animation_tablet&quot;:&quot;none&quot;}">
                              <div class="elementor-widget-wrap elementor-element-populated">
                                <div class="elementor-element elementor-element-17e5e799 elementor-widget elementor-widget-heading" data-id="17e5e799" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-heading-title elementor-size-default">Client</div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-7cdf4100 elementor-widget elementor-widget-heading" data-id="7cdf4100" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <h4 class="elementor-heading-title elementor-size-default">{{ projectStore.details.clientName }}</h4>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-61530339 elementor-widget elementor-widget-spacer" data-id="61530339" data-element_type="widget" data-e-type="widget" data-widget_type="spacer.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-spacer">
                                      <div class="elementor-spacer-inner"></div>
                                    </div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-5b49ff1d elementor-widget elementor-widget-heading" data-id="5b49ff1d" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-heading-title elementor-size-default">Sector</div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-12f476c5 elementor-widget elementor-widget-heading" data-id="12f476c5" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <h4 class="elementor-heading-title elementor-size-default">{{ projectStore.details.categoryId?.name }}</h4>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-61530339 elementor-widget elementor-widget-spacer" data-id="61530339" data-element_type="widget" data-e-type="widget" data-widget_type="spacer.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-spacer">
                                      <div class="elementor-spacer-inner"></div>
                                    </div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-5b49ff1d elementor-widget elementor-widget-heading" data-id="5b49ff1d" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-heading-title elementor-size-default">Duration</div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-12f476c5 elementor-widget elementor-widget-heading" data-id="12f476c5" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <h4 class="elementor-heading-title elementor-size-default">{{ projectStore.details.duration }}</h4>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-61530339 elementor-widget elementor-widget-spacer" data-id="61530339" data-element_type="widget" data-e-type="widget" data-widget_type="spacer.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-spacer">
                                      <div class="elementor-spacer-inner"></div>
                                    </div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-5b49ff1d elementor-widget elementor-widget-heading" data-id="5b49ff1d" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-heading-title elementor-size-default">Start - End</div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-12f476c5 elementor-widget elementor-widget-heading" data-id="12f476c5" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <h4 class="elementor-heading-title elementor-size-default">{{ new Date(projectStore.details.startDate).toDateString() }} - {{ new Date(projectStore.details.endDate).toDateString() }}</h4>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-b0d289f elementor-widget elementor-widget-spacer" data-id="b0d289f" data-element_type="widget" data-e-type="widget" data-widget_type="spacer.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-spacer">
                                      <div class="elementor-spacer-inner"></div>
                                    </div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-47371a56 elementor-widget elementor-widget-heading" data-id="47371a56" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <div class="elementor-heading-title elementor-size-default">Location</div>
                                  </div>
                                </div>
                                <div class="elementor-element elementor-element-42bc73d1 elementor-widget elementor-widget-heading" data-id="42bc73d1" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <h4 class="elementor-heading-title elementor-size-default">{{ projectStore.details.address }}, {{ projectStore.details.district }}, {{ projectStore.details.city }} - {{ projectStore.details.country }}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="elementor-column elementor-col-70 elementor-top-column elementor-element elementor-element-38ae83b6" data-id="38ae83b6" data-element_type="column" data-e-type="column">
                              <div class="elementor-widget-wrap elementor-element-populated">
                                <div class="elementor-element elementor-element-2215707a elementor-invisible elementor-widget elementor-widget-heading" data-id="2215707a" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="heading.default">
                                  <div class="elementor-widget-container">
                                    <h2 class="elementor-heading-title elementor-size-default">{{ projectStore.details.projectName }}</h2>
                                  </div>
                                </div>
                                <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-5d498755 elementor-invisible elementor-widget elementor-widget-text-editor" data-id="5d498755" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeIn&quot;,&quot;_animation_delay&quot;:300,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="text-editor.default">
                                  <div class="elementor-widget-container" v-html="projectStore.details.details"></div>
                                </div>
                                <!-- <section class="elementor-section elementor-top-section elementor-element elementor-element-42cf59d elementor-section-boxed elementor-section-height-default elementor-section-height-default">
                                  <div  class="elementor-container elementor-column-gap-no">
                                    <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-18cba20">
                                      <div class="elementor-widget-wrap elementor-element-populated">
                                        <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-feb43ff vamtam-has-hr-layout vamtam-nav-pos-custom elementor-grid-3 elementor-grid-tablet-2 elementor-grid-mobile-1 elementor-posts--thumbnail-top vamtam-has-nav vamtam-has-title-underline-anim vamtam-has-read-more-theme-style elementor-widget elementor-widget-posts" data-id="feb43ff" data-element_type="widget" data-e-type="widget" data-settings="{&quot;vamtam_classic_columns&quot;:&quot;3&quot;,&quot;vamtam_classic_columns_tablet&quot;:&quot;2&quot;,&quot;vamtam_classic_columns_mobile&quot;:&quot;1&quot;,&quot;vamtam_classic_row_gap&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:35,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="posts.vamtam_classic">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-posts-container elementor-posts elementor-posts--skin-vamtam_classic elementor-grid" role="list">
                                              <article v-for="gallery in projectStore.gallerys" :key="gallery.id" class="elementor-post elementor-grid-item post-354 post type-post status-publish format-standard has-post-thumbnail hentry category-projects tag-buildings tag-residential" role="listitem">
                                                <div class="vamtam-post-thumb-wrap">
                                                  <a class="elementor-post__thumbnail__link">
                                                    <div class="elementor-post__thumbnail">
                                                      <img decoding="async" width="586" height="762" :src="gallery.banner" class="attachment-full size-full wp-image-281" alt="" :data-lazy-srcset="gallery.banner + ` 586w, ` + gallery.banner + ` 231w`" data-lazy-sizes="(max-width: 586px) 100vw, 586px" :data-lazy-src="gallery.banner" />
                                                      <noscript><img loading="lazy" decoding="async" width="586" height="762" :src="gallery.banner" class="attachment-full size-full wp-image-281" alt="" :srcset="gallery.banner + ` 586w, ` + gallery.banner + ` 231w`" sizes="(max-width: 586px) 100vw, 586px" /></noscript>
                                                    </div>
                                                  </a>
                                                </div>
                                              </article>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </section> -->
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </article>
      <br />
      <article class="single-post-wrapper full post-5384 post type-post status-publish format-standard has-post-thumbnail hentry category-projects tag-public-buildings">
      </article>
    </div>
    <!-- #main -->
  </div>
  <!-- #main-content -->
</template>

<script>
  // import { Splide, SplideSlide } from '@splidejs/vue-splide';
  // import '@splidejs/vue-splide/css';
  import "@/assets/css/projectdetail.css";

  import { onMounted, watch } from 'vue'
  import { useProjectStore } from '@/stores/projectStore'


  export default {
    name: 'ProjectDetailsView',
    props: {
      slug: String
    },
    setup(props) {
      const projectStore = useProjectStore()

      // const slideOptions = {
      //   type: 'loop',
      //   pagination: false,
      //   arrows: false,
      //   cover: false,
      //   // fixedHeight: "760px",
      //   // height: "100%",
      //   // width: "100%",
      //   heightRatio : 0.3,
      //   autoplay: true,
      //   pauseOnHover: false,
      //   pauseOnFocus: false,
      // };

      onMounted(async () => {
        await projectStore.fetchProjectDetailsBySlug(props.slug)
      })

      watch(() => props.slug,
        async (newSlug) => {
          await projectStore.fetchProjectDetailsBySlug(newSlug)
        }
      )
      return {
        projectStore,
        // slideOptions
      }
    },
    components: {
      // Splide, 
      // SplideSlide,
    },
    data() {
      return {
        // slideOptions: slideOptions,
      }
    },
    computed: {
    },
  }
</script>

<style scoped>
  .elementor-5384 .elementor-element.elementor-element-6ed6fbde:not(.elementor-motion-effects-element-type-background), .elementor-5384 .elementor-element.elementor-element-6ed6fbde > .elementor-motion-effects-container > .elementor-motion-effects-layer {
    /* background-image: none; */
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  

  .elementor-kit-5 h1 {
    font-size: 40px;
  }
  .elementor-kit-5 h2 {
    font-size: 28px;
  }
  .elementor-kit-5 h4 {
    font-size: 16px;
    font-weight: 400;
  }
  .elementor-5384 .elementor-element.elementor-element-17e5e799 .elementor-heading-title {
    font-size: 12px;
  }
  .elementor-2217 .elementor-element.elementor-global-10925 .elementor-post__title, .elementor-2217 .elementor-element.elementor-global-10925 .elementor-post__title a {
    font-size: 24px;
  }
  .elementor-6907 .elementor-element.elementor-element-63898ee4 .elementor-post__title, .elementor-6907 .elementor-element.elementor-element-63898ee4 .elementor-post__title a {
    font-size: 18px;
  }

  .elementor-5384 .elementor-element.elementor-element-5d498755 {
    font-size: 14px;
  }
</style>